module.exports = __webpack_public_path__ + "static/media/10.f7e36d8c.jpg";